
define('tpl!taoQtiTest/runner/ui/toolbox/templates/toolbox', ['handlebars'], function(hb){ 
return hb.template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  


  return "<ul class=\"plain tools-box-list\"></ul>";
  });
});

